let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kFjg9")).then(() => parcelRequire('4zl0K'));